interface SanityTableNode {
  rows?: Array<{ _key: string; cells?: string[] }>
}

// @sanity/table has no header flag, so the first row is rendered as the header
export const SanityTable = ({ node }: { node: SanityTableNode }): React.ReactElement | null => {
  const [header, ...body] = node.rows ?? []
  if (!header) return null

  return (
    <div className="mb-3 overflow-x-auto rounded-2 border border-gray-extra-light">
      <table className="w-full border-collapse text-left">
        <thead>
          <tr className="bg-gray-light">
            {header.cells?.map((cell, index) => (
              <th className="first:w-3/5 px-4 py-2 font-normal" key={index}>
                {cell}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {body.map((row) => (
            <tr className="border-t border-gray-extra-light" key={row._key}>
              {row.cells?.map((cell, index) => (
                <td className="px-4 py-2" key={index}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
